import { Badge } from "@/components/ui/badge";
import { WifiOff, Wifi } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface OfflineStatusIndicatorProps {
  isOnline: boolean;
  queueSize: number;
}

export function OfflineStatusIndicator({
  isOnline,
  queueSize,
}: OfflineStatusIndicatorProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <div className="flex-shrink-0 mt-0.5">
        {isOnline ? (
          <Wifi className="h-4 w-4 text-emerald-600" />
        ) : (
          <WifiOff className="h-4 w-4 text-amber-600" />
        )}
      </div>

      <div className="flex items-center gap-2">
        <span className="font-semibold text-sm">
          {t(`offlineStatus.${isOnline ? "online" : "offline"}`)}
        </span>
        {queueSize > 0 && (
          <Badge
            variant="secondary"
            className={cn("text-xs", {
              "bg-emerald-100 text-emerald-700": isOnline,
              "bg-amber-100 text-amber-700": !isOnline,
            })}
          >
            {t("offlineStatus.queuedRequests", { count: queueSize })}
          </Badge>
        )}
      </div>
    </div>
  );
}
